export const blockIconsImageCamera = (
	<span className='material-symbols-outlined'>camera</span>
);
